// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"226":"1f269107","418":"08154570","466":"2b492376","472":"bbc1c5dd","531":"4b2bf36d","639":"55342ebe","683":"068cdfb4"}[chunkId] + ".css";
};